import {Component} from "@angular/core";
import {NavController, NavParams} from "ionic-angular";
import {UserService} from "../../app/services/user.service";
import {Product} from "../../app/classes/product";
import {CartService} from "../../app/services/cart.service";

@Component({
  selector: 'page-favorite',
  templateUrl: 'favorite.html',
  providers: [UserService, CartService]
})
export class FavoritePage {
  public products: Product[] = [];

  constructor(public cartService: CartService, public userService: UserService, public navCtrl: NavController, public navParams: NavParams) {
    this.userService.getFavorites().then((favorites) => {
      this.products = favorites;
    });
  }

  isFavorite(product: Product) {
    let result = false;
    this.products.forEach((favorite) => {
      if (favorite.number == product.number) {
        result = true;
      }
    });
    return result;
  }

  addProductToCart(product: Product) {
    this.cartService.getCart().addProduct(product,
      {
        added: [],
        removed: []
      });
  }

  favoriteProduct(product: Product) {
    this.userService.addFavorite(product);
    this.products.push(product);
  }

  unfavoriteProduct(product: Product) {
    this.userService.removeFavorite(product);
    this.products = this.products.filter((f) => {
      return f.number !== product.number;
    });
  }
}



// WEBPACK FOOTER //
// ./src/pages/favorite/favorite.ts